import React, {useContext } from 'react'
import './Carousel.css'
import CurrentUserContext from '../../Contexts/userContexts'

const SlideTwo = () => {

    const { singlePlayer } = useContext(CurrentUserContext);
    let max = singlePlayer.length - 1;
    let min = 0;
    const displayPlayers = [];
    let value = Math.floor(Math.random() * (max - min + 1) + min);


    singlePlayer.filter((el, index) => value === index).map(filteredPerson => (
        displayPlayers.push(filteredPerson.player[0])
    ))

    return (
        <div className='slideTwo'>
                       <div className="modal-content">
                           <div className="allCard">
                               <div style={{ backgroundColor: `${displayPlayers[0].strTeamColor}` }} className='playerCard'>
                                   <div className='teamInformation'>
                                       <img className='teamBagde' src={displayPlayers[0].strTeamBadge} alt={`${displayPlayers[0].strPlayer} team bagde`} />
                                       {/* Equipa do jogador*/}
                                       <h2 className='playerTeam'>{displayPlayers[0].strTeam}</h2>
                                   </div>
                                   <div className='playerInformation'>
                                       {/* imagem */}
                                       <img className='playerImage' src={displayPlayers[0].strCutout} alt={`${displayPlayers[0].strPlayer}`} />
                                       {/* nome do jogador */}
                                       {/* numero de jogador */}
                                       <div className='playerNumberDiv' style={{ backgroundColor: `${displayPlayers[0].strTeamColor}` }}><h2 className='playerNumber'>{displayPlayers[0].strNumber}</h2></div>
                                       {/* numero de jogador */}
                                       <h1 className='playerName'>{displayPlayers[0].strPlayer}</h1>
                                       <div className='slideTwoCard'>
                                           <div className='slideTwoCardMore'>
                                               <div className="playerText">
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                               <div className="playerInfo">
                                   <h1 className='text'>{displayPlayers[0].strPlayer}</h1>
                                   <ul>
                                       <li className="text">Nationality: {displayPlayers[0].strNationality}</li>
                                       <li className="text">Team: {displayPlayers[0].strTeam} - squad number: {displayPlayers[0].strNumber}</li>
                                       <li className="text">Date of Birth: {displayPlayers[0].dateBorn}</li>
                                       <li className="text">Position: {displayPlayers[0].strPosition}</li>
                                       <li className="text">Height: {displayPlayers[0].strHeight}</li>
                                       <li className="text">Weight: {displayPlayers[0].strWeight}</li>
                                   </ul>
                               </div>
                           </div>
                       </div>
                   </div>
               
               

    )
}

export default SlideTwo
